import { fetchAuthSession } from 'aws-amplify/auth';
import axios, {
  AxiosError,
  AxiosInstance,
  InternalAxiosRequestConfig,
} from 'axios';
import axiosRetry from 'axios-retry';
import { Store, iNotification } from 'react-notifications-component';

// App Settings
import { NetworkSettings } from '_utils';

// Create notification store instance

interface ApiResponse<T = any> {
  result: T;
  data: {
    title?: string;
  };
}

interface ApiError {
  type: string;
  title: string;
  status: number;
  detail: string;
  instance: string;
  isError: boolean;
  errors: any;
  validationErrors: any;
  details: any;
}

const RequestApi: AxiosInstance = axios.create({
  baseURL: NetworkSettings?.fullApiUrl,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
  },
});

axiosRetry(RequestApi, {
  retries: 0,
  retryDelay: (retryCount: number): number => {
    console.log(`retry attempt: ${retryCount}`);
    return retryCount * 2000;
  },
  retryCondition: (error: AxiosError): boolean => {
    return error?.response?.status !== 409;
  },
});

RequestApi.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const selectedLanguage = localStorage.getItem('i18nextLng') || 'en';
    const session = await fetchAuthSession();

    const { idToken, accessToken } = session.tokens ?? {};

    console.log('idToken', idToken);

    console.log(accessToken, accessToken);

    config.headers = config.headers || {};
    config.headers['X-App-Language'] = `${selectedLanguage}`;
    config.headers['X-App-Key'] = NetworkSettings?.appKey;
    config.headers['X-App-Version'] = NetworkSettings?.appVersion;
    config.headers['X-Order-Source'] = 'Web';
    idToken && (config.headers['Authorization'] = `Bearer ${idToken}`);

    return config;
  },
  (error: AxiosError) => Promise.reject(error),
);

RequestApi.interceptors.response.use(
  (response: { data: ApiResponse }) => {
    return response.data.result;
  },
  (error: AxiosError) => {
    const notification: iNotification = {
      title: 'Something Went Wrong',
      message:
        (error?.response?.data as ApiError)?.detail || 'An error occurred',
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      animationIn: ['animate__animated', 'animate__fadeIn'],
      animationOut: ['animate__animated', 'animate__fadeOut'],
      dismiss: {
        duration: 3000,
        onScreen: true,
      },
    };

    Store.addNotification(notification);

    return Promise.reject(error?.response?.data || error);
  },
);

export default RequestApi;
